import {ScopeValues} from '@dms/api/shared';

export const evaluatePaymentMethod = (scopes: string[], evaluatorParams: ScopeValues) => {
  if (evaluatorParams && 'paymentMethod' in evaluatorParams) {
    return scopes.includes(evaluatorParams.paymentMethod);
  }
  return false;
};
